import { createAsyncThunk } from "@reduxjs/toolkit";

import apiRequest from "../../../services/api";
import { validateTip } from "../../features/feed/tipSlice";

export const listTips = createAsyncThunk(
  "feed/list_tips",
  async (body, { rejectWithValue }) => {
    let query = `page=${body.page ? body.page : 1}&`;
    if (body.page_size) {
      query = query + `page_size=${body.page_size}&`;
    }
    if (body.categories) {
      query = query + `categories=${body.categories}&`;
    }
    if (body.search) {
      query = query + `search=${body.search}&`;
    }
    if (body.orderby) {
      query = query + `ordering=${body.orderby}&`;
    }
    try {
      const tips = await apiRequest.get(`v1/tips/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      });
      return tips.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const createTips = createAsyncThunk(
  "feed/create_tips",
  async (body, { getState, rejectWithValue, dispatch }) => {
    dispatch(validateTip());
    const state = getState();
    const tipValidationErrors = state.tips.tipValidationErrors;
    if (Object.keys(tipValidationErrors).length > 0) {
      return rejectWithValue(tipValidationErrors);
    }
    try {
      const newTips = await apiRequest.post(`v1/tips/`, body.newTipsData, {
        headers: { organization: body.userOrganization.org_id },
      });
      return newTips;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateTips = createAsyncThunk(
  "feed/update_tips",
  async (body, { getState, rejectWithValue, dispatch }) => {
    dispatch(validateTip());
    const state = getState();
    const tipValidationErrors = state.tips.tipValidationErrors;
    if (Object.keys(tipValidationErrors).length > 0) {
      return rejectWithValue(tipValidationErrors);
    }
    try {
      const newTips = await apiRequest.patch(
        `v1/tips/${body.tipsId}/`,
        body.newTipsData,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return newTips;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteTips = createAsyncThunk(
  "feed/delete_tips",
  async (body, { rejectWithValue }) => {
    try {
      const tipsDelete = await apiRequest.delete(`v1/tips/${body.tipsId}/`, {
        headers: { organization: body.userOrganization.org_id },
      });
      return tipsDelete.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchTipsDetails = createAsyncThunk(
  "feed/fetch_tips_details",
  async (body, { rejectWithValue }) => {
    try {
      const tipsDetails = await apiRequest.get(`v1/tips/${body.tipsId}/`, {
        headers: { organization: body.userOrganization.org_id },
      });
      return tipsDetails.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const duplicateTips = createAsyncThunk(
  "feed/duplicate_tips",
  async (body, { rejectWithValue }) => {
    try {
      const tipsDuplicate = await apiRequest.post(
        `v1/tips/${body.tipsId}/duplicate/`,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return tipsDuplicate;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
